import React from 'react';
import { t, defineMessages } from '@sm/intl';
import { createURL } from '@sm/utils';
import { TopBarSlim } from '../TopBarSlim';
import { UseCaseVariationEnums } from '../TopBarSlimEnums';

const DEFAULT_COPY = defineMessages({
  MESSAGE: {
    id: 'UseCaseFormsApplicationsTopBarSlim.message',
    defaultMessage:
      'Accept payments along with your forms-in one place at one time.',
    description: '[Type: Paragraph][Vis.: low] - Top bar slim message',
  },
  CTA_TEXT: {
    id: 'UseCaseFormsApplicationsTopBarSlim.ctaText',
    defaultMessage: 'Upgrade to unlock payments',
    description: '[Type: Button][Vis.: low] - Top bar slim cta text',
  },
});

const COLLECT_COPY = defineMessages({
  MESSAGE: {
    id: 'UseCaseFormsApplicationsTopBarSlim.messageCollect',
    defaultMessage:
      'Make sure every applicant is counted. Unlock unlimited survey responses.',
    description: '[Type: Paragraph][Vis.: low] - Top bar slim message',
  },
  CTA_TEXT: {
    id: 'UseCaseFormsApplicationsTopBarSlim.ctaTextCollect',
    defaultMessage: 'See all plans',
    description: '[Type: Button][Vis.: low] - Top bar slim cta text',
  },
});

const ANALYZE_COPY = defineMessages({
  MESSAGE: {
    id: 'UseCaseFormsApplicationsTopBarSlim.messageAnalyze',
    defaultMessage:
      'Export and print applications to share with colleagues or to save.',
    description: '[Type: Paragraph][Vis.: low] - Top bar slim message',
  },
  CTA_TEXT: {
    id: 'UseCaseFormsApplicationsTopBarSlim.ctaTextAnalyze',
    defaultMessage: 'Unlock exports',
    description: '[Type: Button][Vis.: low] - Top bar slim cta text',
  },
});

export type UseCaseFormsApplicationsTopBarSlimProps = {
  variation?: UseCaseVariationEnums | null;
};

const VariationToCopy = {
  [UseCaseVariationEnums.create]: DEFAULT_COPY,
  [UseCaseVariationEnums.collect]: COLLECT_COPY,
  [UseCaseVariationEnums.analyze]: ANALYZE_COPY,
};

export const UseCaseFormsApplicationsTopBarSlim: React.FC<UseCaseFormsApplicationsTopBarSlimProps> = ({
  variation,
}) => {
  const copy =
    variation && variation in VariationToCopy
      ? VariationToCopy[variation]
      : DEFAULT_COPY;
  const ut_source = variation
    ? `slim_${variation}_upsell_forms_applications`
    : 'slim_create_upsell_forms_applications';

  return (
    <TopBarSlim
      message={t(copy.MESSAGE)}
      ctaText={t(copy.CTA_TEXT)}
      ctaLink={createURL('/pricing/upgrade/', {
        ut_source: 'topbar',
        ut_source2: ut_source,
      })}
      ctaNewTab
    />
  );
};

export default UseCaseFormsApplicationsTopBarSlim;
